class Message extends EventHandler {

  constructor(data, text) {
    super();

    // Use default value instead of null
    if (data.parser === null) delete data.parser;

    Utils.autoFeed(this, [
      "action_link",
      "attachments",
      "bubble_display_time",
      "conv_id",
      "created_at",
      "created_at_ts",
      "custom_class",
      "focus",
      "from_description",
      "answer_type",
      "hash",
      "id",
      "image",
      "interactions",
      "keep_at_bottom",
      "mandatory_buttons",
      "name",
      "parser",
      "plain_text",
      "status",
      "text",
      "translated",
      "translate_reversed",
      "trigger_id",
      "type",
      "user_id",
      "exception_name",
      "exception_data",
      "tool_calls",
      "show_sources"
    ], data);
    if (Utils.defined(text))
      this.text = text;
    if (!this.interactions)
      this.interactions = Message.defaultInteractions();

    if (this.type == "faq")
      this.parser = Message.PARSER.HTML;

    this._conv_id = null;
    this.conversation = null;

    this._lastRender = {
      text: null,
      show_sources: null,
      translate_reversed: null
    };

    // Events that will be automatically removed if the message is removed from the conversation
    this.conversationEvents = [];
  }

  setId(newId) {
    this.constructor.dereference(this.id)
    let element = this.getElement();
    if (element) {
      element.id = 'slaask-message-' + newId;
      Utils.dataSet(element, 'id', newId);
    }
    this.id            = newId;
    this.constructor.reference(this)
  }

  get conv_id() { return this.conversation ? this.conversation.id : this._conv_id; }
  set conv_id(conv_id) { this._conv_id = conv_id; }

  get plain_text() { return Utils.exists(this._plain_text) ? this._plain_text : this.text; }
  set plain_text(txt) { this._plain_text = txt; }

  get attachments() {
    return this._attachments;
  }
  set attachments(attachments) {
    if (!attachments) attachments = [];
    if (!this._attachments) this._attachments = [];
    let differs = !this._attachments || attachments.length != this._attachments.length;
    for (let i = 0 ; i < attachments.length && differs ; i++) {
      if (attachments[i] != this._attachments[i]) differs = true;
    }

    if (differs) {
      this._trigger('attachments_updating', attachments);
      this._attachments = attachments;
      this._trigger('attachments_updated', attachments);
    }
  }

  formatedFromDescription() {
    if (this.answer_type == 'ai') {
      return `<span class="description">${Wording.ai_description}</span>`;
    }

    return this.from_description
            ? `<span class="description">${this.from_description}</span>`
            : '';
  }

  formatedStatus() {
    switch (this.status) {
      case 1:
        return Wording.message_sending_text;
      case 2:
        return Wording.message_delivered_text;
      case 3:
        return Wording.message_delivered_seen_text;
    }
    return '';
  }

  fromVisitor() { return this.fromGuest.apply(this, arguments); }
  fromGuest() {
    return this.name == "me";
  }

  // Only call this function from the render method and only once
  textChangedSinceLastRender() {
    const different = Object.keys(this._lastRender).map(property => {
      const different = this[property] !== this._lastRender[property];
      this._lastRender[property] = this[property];
      return different;
    }).reduce((acc, curr) => acc || curr, false);
    return different;
  }

  /**
   * See Interaction.js
   * @param {Interaction|Object} interactionData Hash or Interaction
   * @returns {Interaction}
   */
  addInteraction(interactionData) {
    this.interactions.push(interactionData.constructor == Interaction
                            ? interactionData
                            : new Interaction(interactionData));
    return this.interactions[this.interactions.length - 1];
  }

  /**
   * @param  {Interaction} interaction
   */
  removeInteraction(interaction) {
    let index = this.interactions.indexOf(interaction);
    if (~index) this.interactions.splice(index, 1);
  }

  hasEphemeralAttachment() {
    let hasEphemeralAttachment = false;
    Utils.forEach(this.attachments, attachment => {
      if (attachment.type == "Attachment::EphemeralButton") {
        hasEphemeralAttachment = true;
      }
    });
    return hasEphemeralAttachment;
  }

  hasMandatoryAttachment() {
    let hasMandatoryAttachment = false;
    Utils.forEach(this.attachments, attachment => {
      if ((attachment.type == "Attachment::EphemeralButton" || attachment.type == "Attachment::Rating" || attachment.type == "Attachment::Input") && attachment.options.mandatory) {
        hasMandatoryAttachment = true;
      }
    });
    return hasMandatoryAttachment;
  }

  removeEphemeralAttachments() {
    if (this.hasEphemeralAttachment()) {
      this._trigger('attachments_updating', this.attachments);
      for (let i = this.attachments.length - 1 ; i >= 0 ; i--) {
        if (this.attachments[i].type == "Attachment::EphemeralButton") {
          this.attachments.splice(i, 1);
        }
      }
      this._trigger('attachments_updated', this.attachments);
    }
  }

  removeAttachment(attachment) {
    let index = this.attachments.indexOf(attachment)
    if (~index) {
      this._trigger('attachments_updating', this.attachments);
      this.attachments.splice(index, 1);
      this._trigger('attachments_updated', this.attachments);
    }
  }

  removeAttachmentsFromId(attachments_id) {
    this._trigger('attachments_updating', this.attachments);
    attachments_id.forEach(id => {
      let attachment = this.attachments.filter(attachment => attachment.id == id)[0]
      if (attachment) {
        let index = this.attachments.indexOf(attachment)
        if (~index) {
          this.attachments.splice(index, 1);
        }
      }
    })
    this._trigger('attachments_updated', this.attachments);
  }

  /**
   * getElement
   * For readonly purposes only.
   * Change message.text then use Conversations.updateMessage(message) instead.
   *
   * @return {HTMLDivElement}
   */
  getElement() {
    return Dom.findById('widget', this.getElementId());
  }

  getElementId() {
    return 'slaask-message-' + this.id;
  }

  querySelector() {
    let element = this.getElement();
    return element ? element.querySelector.apply(element, arguments) : null;
  }

  querySelectorAll() {
    let element = this.getElement();
    return element ? element.querySelectorAll.apply(element, arguments) : [];
  }

}

Message.all = {};

Message.defaultInteractions = () => {
  return [
    {
      selector: '.translated-label',
      event: 'click',
      handler: e => {
        e.preventDefault();

        let message = Message.get(e.currentTarget.id.replace('translated-label-', ''))

        message.translate_reversed = Utils.hasClass(e.currentTarget, 'is-translated')

        Conversations.updateMessage(message, true)
      }
    },
    {
      selector: '.youtube-preview',
      event: 'click',
      handler: e => {
        e.preventDefault();

        let messageId   = e.target.parentElement.parentElement.parentElement.parentElement.parentElement.id.replace('slaask-message-', '')
        let message     = Message.get(messageId)
        let videoId     = e.target.src.replace('https://i1.ytimg.com/vi/', '').replace('/mqdefault.jpg', '')
        let iframeHeigh = e.target.height

        let origin = encodeURIComponent(Dom.parent.location.origin)

        message.text = message.text.replace(e.target.outerHTML, `<iframe style="height:${iframeHeigh}px" id="player-${messageId}" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" title="YouTube video player" width="640" height="360" src="https://www.youtube.com/embed/${videoId}?autoplay=1&controls=1&modestbranding=1&origin=${origin}"></iframe>`)

        Conversations.updateMessage(message)
      }
    },
    {
      selector: 'img',
      event: 'click',
      handler: e => {
        if (e.target.tagName == 'IMG' && Utils.dataSet(e.target, 'file-type') == 'image') {
          try {
            const imageData = JSON.parse(decodeURIComponent(Utils.dataSet(e.target, 'file')))
            if (imageData && imageData.src) {
              window.open(imageData.src)
            }
          } catch (error) {
            Utils.log(error)
          }
        }
      }
    },
    {
      selector: '.tool-call-show-sources',
      event: 'click',
      handler: e => {
        e.preventDefault();

        let messageId   = e.target.id.replace('show-sources-', '')
        let message     = Message.get(messageId)

        message.show_sources = true

        Conversations.updateMessage(message)
      }
    },
    {
      selector: '.tool-call-hide-sources',
      event: 'click',
      handler: e => {
        e.preventDefault();

        let messageId   = e.target.id.replace('hide-sources-', '')
        let message     = Message.get(messageId)

        message.show_sources = false

        Conversations.updateMessage(message)
      }
    }
  ]
}

Message.get = (id) => {
  return Message.all[id.toString()];
};

Message.reference = (message) => {
  Message.all[message.id.toString()] = message;
};

Message.dereference = (id) => {
  delete Message.all[id.toString()];
};

Message.STATUS = {
  SENDING: 1,
  DELIVERED: 2,
  UNREAD: 2,
  READ: 3,
  DELIVERED_BY_EMAIL: 4,
  READ_BY_EMAIL: 5
};

// See message.rb
Message.PARSER = {
  HTML: 0,
  MARKDOWN: 1,
  MD: 1,
  TEXT: 2
};
